/* eslint-disable import/no-duplicates */
import { format, set } from 'date-fns';
import enUS from 'date-fns/locale/en-US';
import ptBR from 'date-fns/locale/pt-BR';
import { ReactNode } from 'react';
import i18n from 'i18n';
import { capitalizeFirstLetter } from 'helpers/capitalizeFirstLetter';

interface ReturnRenderMonthsGuideValues {
  headers: ReactNode;
  required: ReactNode;
  values: ReactNode;
  examples: ReactNode;
  restrictions: ReactNode;
}

export function getMonthsGuideValues(): ReturnRenderMonthsGuideValues {
  const date = new Date();
  const headers: ReactNode[] = [];
  const required: ReactNode[] = [];
  const restrictions: ReactNode[] = [];
  const values: ReactNode[] = [];
  const examples: ReactNode[] = [];

  const restrictionMonth = (month: string) => (
    <td key={`restriction-${month.toLowerCase()}`}>
      Deve estar no formato: XXXXXX
    </td>
  );

  const noRequired = (month: string) => (
    <td key={`required-${month.toLowerCase()}`}>
      Não
    </td>
  );

  const exampleMonth = (month: string) => (
    <td key={`example-${month.toLowerCase()}`}>12.000</td>
  );

  for (let i = 0; i < 12; i++) {
    const month = format(set(date, {
      date: 1,
      month: i,
    }), 'MMM', {
      locale: i18n.language === 'pt' ? ptBR : enUS,
    });

    headers.push(
      <th key={`header-goal-${month.toLowerCase()}`}>
        Meta kWh
        {' '}
        {capitalizeFirstLetter(month)}
      </th>,
    );
    restrictions.push(
      restrictionMonth(month),
    );
    required.push(
      noRequired(month),
    );
    values.push(
      <td key={`value-month-${month.toLowerCase()}`} />,
    );
    examples.push(
      exampleMonth(month),
    );
  }

  return {
    headers,
    examples,
    required,
    values,
    restrictions,
  };
}

export function getUnitsList(units: { id: number, name: string }[]): {
  ids: ReactNode[];
  unitNames: ReactNode[];
} {
  const ids: ReactNode[] = [];
  const unitNames: ReactNode[] = [];

  for (const unit of units) {
    ids.push(
      <span key={`unit-id-${unit.id}`}>
        {unit.id}
      </span>,
    );
    unitNames.push(
      <span key={`unit-name-${unit.id}`}>
        {unit.name}
      </span>,
    );
  }

  return {
    ids,
    unitNames,
  };
}

export function renderHeaders(headers: string[], monthHeaders: ReactNode): ReactNode {
  return (
    <thead>
      <tr>
        {headers.map((item) => (
          <th key={`header-${item.toLowerCase()}`}>
            {item}
          </th>
        ))}
        {monthHeaders}
      </tr>
    </thead>
  );
}

export function renderRow(label: string, values: ReactNode[], monthCells: ReactNode): ReactNode {
  return (
    <tr key={`row-${label.toLowerCase()}`}>
      <td>{label}</td>
      {
        values.map((item, index) => (
          <td key={`${label}-${index}`}>
            {item}
          </td>
        ))
      }
      {monthCells}
    </tr>
  );
}
